export default "__VITE_ASSET__Dscy8NPi__"